import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer data-testid="footer" className="bg-[#0D1220] border-t border-white/5 py-16">
      <div className="max-w-6xl mx-auto px-6 text-center">
        {/* Logo */}
        <img
          src="https://customer-assets.emergentagent.com/job_wind-services-hub/artifacts/gy20fiwt_Yira-Wind-Services-logo-rojo-blanco.svg"
          alt="Yira Wind Services"
          className="h-12 mx-auto mb-6"
        />

        <p data-testid="footer-location" className="text-[#B0B0B0] text-sm mb-2">
          {t.footer.location}
        </p>

        <a
          href="https://yirawindservices.mx"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-website"
          className="text-[#B0B0B0] text-sm hover:text-[#E71C25] transition-colors duration-300 inline-block mb-4"
        >
          yirawindservices.mx
        </a>

        <p data-testid="footer-certs" className="text-white/50 text-xs tracking-wider uppercase mb-2">
          {t.footer.certifications}
        </p>

        <p data-testid="footer-tagline" className="text-white/30 text-xs tracking-wider uppercase">
          {t.footer.tagline}
        </p>
      </div>
    </footer>
  );
}
